import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

// Styled components
const Button = styled.button`
  display: flex;
  padding: ${(props) => (props.isViewMobile ? "4px 6px" : "14px")};
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
  background: ${(props) => (props.isLock ? "#e0e0e0" : "#FFF")}; // Locked state style
  border: none;
  cursor: ${(props) => (props.isLock ? "not-allowed" : "pointer")}; // Disable cursor when locked
  margin-right: 12px;
  height: ${(props) => (props.isViewMobile ? "30px" : "55px")};
  opacity: ${(props) => (props.isLock ? 0.6 : 1)}; // Dim the button when locked
`;

const Icon = styled.img`
  width: ${(props) => (props.isViewMobile ? "15px" : "32px")};
  height: ${(props) => (props.isViewMobile ? "15px" : "32px")};
`;

const Text = styled.span`
  color: #121926;
  font-size: ${(props) => (props.isViewMobile ? "12px" : "18px")};
  font-weight: 500;
  margin-left: ${(props) => (props.isViewMobile ? "12px" : "4px")};
  white-space: nowrap;
`;

const ButtonOnChatScreen = ({ icon, text, handleClick, isViewMobile }) => {
  const isChatPending = useSelector((state) => state.isChatPending || {});
  const isLock = isChatPending?.isLock;

  return (
    <Button 
      isViewMobile={isViewMobile} 
      onClick={handleClick} 
      isLock={isLock} // Pass the lock condition to the button
      disabled={isLock} // Optionally disable the button
    >
      <Icon src={icon} alt="Button Icon" isViewMobile={isViewMobile} />
      <Text isViewMobile={isViewMobile}>{text}</Text>
    </Button>
  );
};

export default ButtonOnChatScreen;